<template>
  <div class="row m-0">
    <div class="col-12 p-3 mt-3 card dropshadow">
      <a
        class
        href
        role="button"
        aria-controls="collapseExample"
        @click.prevent="chooseDeliveryAddress"
        id="buy-now-delivery-address"
        data-test="deliveryAddressLink"
      >
        <h4 class="m-0" id="delivery-heading" data-test="deliveryAddressHead">1. Delivery Address</h4>
      </a>
      <div class="collapse mt-3" id="collapse-address">
        <div class="row m-0">
          <address-list-template
            @addressChoosed="updateDom()"
            v-for="(address, index) in customerAddress"
            :key="index"
            :data="deliveryAddress"
            :address="address"
            @cancel="hideAddressDataFunction($event)"
            @updateSuccess="hideAddressData = false"
          ></address-list-template>
        </div>
        <div class="col-12 card p-3" v-if="(!showAddAddressForm)" v-show="!hideAddressData">
          <div class="custom-control custom-radio" id="dlvry-addrssform-radio">
            <a
              class
              data-toggle="collapse"
              href="#addnew-address"
              role="button"
              aria-expanded="false"
              aria-controls="collapseExample"
              @click.prevent="showAddAddressForm = true"
              id="addNewAddress"
              data-test="deliveryAddressNewLink"
            >
              <label
                class="custom-control-label"
                for="addNewAddress"
                id="dlvry-addrs-form"
                data-test="deliveryAddressNewLabel"
              >Add New</label>
            </a>
          </div>
        </div>
        <address-form
          v-if="showAddAddressForm"
          @cancel="showAddAddressForm = false"
          @submitSuccess="addOrUpdateAddress($event)"
        ></address-form>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-9">
            <form class="needs-validation" novalidate>
              <button
                type="button"
                name
                id="dlvry-addrss-continue-btn"
                class="btn btn-primary blue-btn mt-4"
                @click.prevent="continueToOrderSummary"
                v-if="(getSelectedAddressId && (!showAddAddressForm))"
                data-test="deliveryAddressBtn"
              >Continue</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { customerApi } from '@/services/ApiServices/customerApi'
import AddressListTemplate from '@/components/widgets/user/AddressListTemplate'
import AddressForm from '@/components/shared/forms/AddressForm'
import { mapActions, mapGetters } from 'vuex'

export default {
	props: {},
	components: {
		AddressListTemplate,
		AddressForm
	},
	beforeMount () {
		this.setSelectedAddressIdData('')
		this.setSelectedAddressData({})
		this.bindCustomerAddress()
	},
	mounted () {
		if (
			Object.getOwnPropertyNames(
				JSON.parse(JSON.stringify(this.getSelectedAddress))
			).length !== 0
		) {
			this.deliveryAddress.selectedAddress = this.getSelectedAddress
		} else if (this.customerAddress && this.customerAddress.length > 0) {
			this.deliveryAddress.selectedAddress = this.customerAddress[0]
		}
		this.setShowCharge(false)
	},
	data () {
		return {
			customerAddress: [],
			showAddAddressForm: false,
			hideAddressData: false,
			deliveryAddress: { selectedAddress: '' }
		}
	},
	computed: {
		...mapGetters('user', ['getSelectedAddressId', 'getSelectedAddress'])
	},
	watch: {
		selectedAddress () {
			this.setSelectedAddressData(this.deliveryAddress.selectedAddress)
			this.setSelectedAddressIdData(
				this.deliveryAddress.selectedAddress.addressId
			)
		},
		deliveryAddress: {
			handler (val) {
				this.setSelectedAddressData(val.selectedAddress)
				this.setSelectedAddressIdData(val.selectedAddress.addressId)
			},
			deep: true
		}
	},
	methods: {
		...mapActions('user', [
			'setAddressData',
			'setSelectedAddressIdData',
			'setSelectedAddressData',
			'deleteAddressData'
		]),
		...mapActions('charges', ['setShowCharge']),
		bindCustomerAddress () {
			customerApi.getAddresses().then(res => {
				if (res.body) {
					this.customerAddress = res.body
					if (
						this.deliveryAddress.selectedAddress === '' &&
            this.customerAddress &&
            this.customerAddress.length > 0
					) {
						this.deliveryAddress.selectedAddress = this.customerAddress[0]
					}
				}
			})
		},
		hideAddressDataFunction (data) {
			this.hideAddressData = data
		},
		addOrUpdateAddress (addressdata) {
			customerApi.addAddress(addressdata).then(() => {
				this.showAddAddressForm = false
				this.bindCustomerAddress()
			})
		},
		deleteAddress (addressId) {
			this.editEnabled = false
			this.deleteAddressData(addressId)
			customerApi.removeAddress(addressId).then(() => {
				this.bindCustomerAddress()
				this.$forceUpdate()
				this.showAddAddressForm = false
			})
		},
		updateDom () {
			const vm = this
			setTimeout(() => {
				vm.$forceUpdate()
			}, 1000)
		},
		continueToOrderSummary () {
			this.setShowCharge(false)
			if (this.getSelectedAddressId) {
				$('#collapse-address').collapse('hide')
				$('#collapse-summary').collapse('show')
				this.$emit('toOrderSummary')
			}
		},
		chooseDeliveryAddress () {
			this.setShowCharge(false)
			$('#collapse-address').collapse('show')
			$('#collapse-summary').collapse('hide')
			$('#collapse-payment').collapse('hide')
		}
	}
}
</script>
